// extracted by mini-css-extract-plugin
module.exports = {"root":"component_root__1FWt_","container":"component_container__1QukW","logo":"component_logo__3Xtas","profile":"component_profile__21vGW","icon":"component_icon__2UDGw"};